export const PEOPLE_SICK_COUNT_MAX_LENGTH = 3;
export const ANIMAL_COUNT_MAX_LENGTH = 5;

export function sanitizeCountInput(value, maxLength) {
  const text = String(value ?? "");
  if (!/^\d*$/.test(text)) return "";
  return text.slice(0, maxLength);
}

export function isPositiveIntegerText(value) {
  return /^[1-9]\d*$/.test(String(value ?? ""));
}
